var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMoneyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1719_6176)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4.34619,
    width: 47.9236,
    height: 47.3462,
    rx: 11.4331,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1719_6176)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 39C34.6274 39 40 33.8513 40 27.5C40 21.1487 34.6274 16 28 16C21.3726 16 16 21.1487 16 27.5C16 33.8513 21.3726 39 28 39Z",
    fill: "#AB54A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.86 28.2955C31.7 27.9361 31.465 27.639 31.145 27.3995C30.83 27.1599 30.43 26.9682 29.95 26.8149C29.71 26.7382 29.445 26.6663 29.165 26.5992V23.7913C29.395 23.8632 29.62 23.9447 29.83 24.0405C30.115 24.1651 30.34 24.2992 30.51 24.443C30.635 24.534 30.78 24.582 30.94 24.582C31.185 24.582 31.395 24.4909 31.575 24.3088C31.755 24.1267 31.845 23.9255 31.845 23.7003C31.845 23.3984 31.69 23.1301 31.385 22.8953C31.015 22.5934 30.535 22.3395 29.95 22.143C29.7 22.0567 29.435 21.9945 29.165 21.9465V21.3955C29.165 21.132 29.08 20.9115 28.905 20.7342C28.73 20.557 28.505 20.4707 28.23 20.4707C27.955 20.4707 27.725 20.5617 27.54 20.7342C27.355 20.9067 27.265 21.132 27.265 21.3955V21.8986C26.835 21.9561 26.425 22.0615 26.045 22.2149C25.445 22.4592 24.965 22.8138 24.61 23.2786C24.255 23.7434 24.08 24.3088 24.08 24.9653C24.08 25.4013 24.155 25.7942 24.3 26.144C24.45 26.4938 24.665 26.7957 24.96 27.0545C25.25 27.3132 25.61 27.524 26.045 27.6917C26.405 27.8307 26.81 27.9361 27.265 28.0176V30.9884C27.005 30.9501 26.77 30.8878 26.56 30.8015C26.165 30.6386 25.765 30.4038 25.365 30.0876C25.205 29.9678 25.025 29.9055 24.825 29.9055C24.56 29.9055 24.34 29.9965 24.165 30.169C23.99 30.3463 23.905 30.5524 23.905 30.7824C23.905 30.9261 23.94 31.0651 24.015 31.2088C24.09 31.3526 24.195 31.4772 24.33 31.5874C24.87 32.033 25.435 32.3445 26.025 32.5217C26.405 32.6367 26.82 32.7134 27.26 32.7517V33.6047C27.26 33.8682 27.35 34.0886 27.53 34.2659C27.71 34.4432 27.93 34.5295 28.195 34.5295C28.46 34.5295 28.7 34.4384 28.885 34.2659C29.07 34.0886 29.16 33.8682 29.16 33.6047V32.6655C29.46 32.6032 29.745 32.517 30.025 32.402C30.645 32.148 31.145 31.7838 31.525 31.3095C31.905 30.8351 32.095 30.2649 32.095 29.6084C32.095 29.0909 32.015 28.6549 31.855 28.2955H31.86ZM27.025 26.1057C26.675 25.9907 26.41 25.8326 26.225 25.6361C26.04 25.4397 25.95 25.1857 25.95 24.8838C25.95 24.6299 26.03 24.4095 26.19 24.213C26.35 24.0213 26.585 23.868 26.895 23.7578C27.01 23.7195 27.135 23.6859 27.27 23.662V26.1776C27.19 26.1536 27.11 26.1297 27.03 26.1057H27.025ZM29.895 30.3895C29.71 30.5715 29.465 30.7201 29.165 30.8351V28.4488C29.49 28.5878 29.74 28.7507 29.91 28.9376C30.1 29.1484 30.195 29.4072 30.195 29.7138C30.195 29.9678 30.095 30.193 29.895 30.3895Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1719_6176",
    x: 0.57006,
    y: 0.916251,
    width: 59.3567,
    height: 58.7793,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.28663,
    dy: 2.28663
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.85828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.403922 0 0 0 0 0.517647 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1719_6176"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1719_6176",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1719_6176"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 23,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoneyIcon);
export default __webpack_public_path__ + "static/media/money-icon.b82e5ad38442d081c54e0e110052c744.svg";
export { ForwardRef as ReactComponent };